<template>
<div class="h-full flex justify-center">
	<div class="flex flex-col h-full w-full">
		<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
			<div class="h-full flex flex-col justify-center control-section">
				<div class="rounded-lg px-6 form-group border-blue-500 pt-7 mx-6 grid justify-items-center">
					<div class="pb-6 w-full max-w-[1300px]">
						<info-header/>
					</div>
						<div class='eny-radio-toolbar max-w-[1300px] flex flex-col sm:flex-row'>
							<div v-for="(radioEl, index) in radios" :key="radioEl.id" class="eny-radio">
								<input type="radio" :id="radioEl.id" name="dashboard_tab" :value="index" v-model="dashboardTab" />
								<label :for="radioEl.id"><span>{{radioEl.label}}</span></label>
							</div>
						</div>
				</div>
				<div class="h-3 grid justify-items-center ">
					<div class="w-full max-w-[1300px]">
						<ejs-progressbar v-if="loading" ref="indeterminate" id="successcontainer" type='Linear' isIndeterminate=true value=20></ejs-progressbar>
					</div>
				</div>
				<dashboard-task v-if='dashboardTab===0'></dashboard-task>
				<dashboard-detail v-else-if='dashboardTab===1'></dashboard-detail>
				<dashboard-eval v-else></dashboard-eval>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { ProgressBarComponent }  from "@syncfusion/ej2-vue-progressbar";
import InfoHeader from "./InfoHeader.vue";
import DashboardTask from "./DashboardTask.vue";
import DashboardDetail from "./DashboardDetail.vue";
import DashboardEval from "./DashboardEval.vue";
import useNotification from "../../hooks/useNotification";
import { mapGetters } from 'vuex';

export default {
	name: "DashboardDetailMain",
	components: {
		'ejs-progressbar': ProgressBarComponent,
		'dashboard-task': DashboardTask,
		'dashboard-detail': DashboardDetail,
		'dashboard-eval': DashboardEval,
		'info-header': InfoHeader,
	},
	setup() {
		const { showNotification } = useNotification();
		return {
			showNotification,
		}
	},
	data() {
		return {
			radios: [{id: 'radio_tasks', label: this.$t('eny.tasks')}, {id: 'radio_data', label: this.$t('eny.data')}, {id: 'radio_evaluation', label: this.$t('eny.evaluation')}],
			dashboardTab: 0,
		};
	},
	computed: {
		...mapGetters('customer', ['loading']),
	},
	watch: {
		message(value, oldValue) {
			if (value !== '') {
				const type = this.success ? 'info' : 'error';
				this.showNotification(value, type, 5);
			}
		},
	},
}
</script>
<style>
</style>
